import {usePathologiesData} from "./usePathologiesData";
import {prescriptionTypeLabel, prescriptionTypeValue} from "./prescriptionTypeData";

export const useTemplateFormLOX_POC_TOC_COX = (t: any, dataForm: any) => {

    const {formStructurePathologies} = usePathologiesData(t, dataForm);

    const formStructureStroller = [
        {
            type: "input",
            label: t(`prescription.template.stroller`),
            col: {xs: "6", sm: "4", lg: "3", xl: "3"},
            name: "stroller",
            dataElement: {
                type: "checkbox"
            },
            display: {
                form: "inlineFormReverse mt-2",
                label: "",
                child: ""
            }
        },
    ]
    const formStructureModel = (type) => [
        {
            name: `model_prod_${type}`,
            type: "input",
            label: `${t(`prescription.template.model_prod`)}`,
            dataElement: {
                placeholder: t(`prescription.template.model_prod_placeholder`),
                type: "text"
            },
            col: {xs: "8", sm: "8", lg: "3", xl: "3"}
        },
    ]
    const formStructurePrescription = (type, hasLevelData?: boolean) => [
        {
            name: `${hasLevelData ? 'level' : 'flow'}_rest_${type}`,
            type: "input",
            label: `${t(`prescription.template.${hasLevelData ? 'levelRest' : 'flowRest'}`)}*`,
            dataElement: {
                placeholder: t(`prescription.template.flowRest_placeholder`),
                type: "text"
            },
            col: {xs: "8", sm: "8", lg: "3", xl: "3"}
        },
        {
            name: `${hasLevelData ? 'level' : 'flow'}_restHourDie_${type}`,
            type: "input",
            label: t("prescription.template.hourDie"),
            dataElement: {
                placeholder: t(`prescription.template.hourDie_placeholder`),
                type: "text"
            },
            col: {xs: "4", sm: "4", lg: "1", xl: "1"},
            display: {
                form: "me-lg-5"
            }
        },
        {
            name: `${hasLevelData ? 'level' : 'flow'}_underStress_${type}`,
            type: "input",
            label: `${t(`prescription.template.${hasLevelData ? 'underStressLevel' : 'underStressFlow'}`)}*`,
            dataElement: {
                placeholder: t(`prescription.template.underStressFlow_placeholder`),
                type: "text"
            },
            col: {xs: "6", sm: "6", lg: "3", xl: "3"}
        },
        {
            name: `${hasLevelData ? 'level' : 'flow'}_underStressHourDie_${type}`,
            type: "input",
            label: t("prescription.template.hourDie"),
            dataElement: {
                placeholder: t(`prescription.template.hourDie_placeholder`),
                type: "text"
            },
            col: {xs: "6", sm: "6", lg: "1", xl: "1"},
            display: {
                form: "me-lg-5"
            }
        },
        {
            name: `${hasLevelData ? 'level' : 'flow'}_night_${type}`,
            type: "input",
            label: `${t(`prescription.template.${hasLevelData ? 'nightLevel' : 'nightFlow'}`)}*`,
            dataElement: {
                placeholder: t(`prescription.template.nightFlow_placeholder`),
                type: "text"
            },
            col: {xs: "6", sm: "6", lg: "3", xl: "3"}
        },
        {
            name: `${hasLevelData ? 'level' : 'flow'}_nightHourDie_${type}`,
            type: "input",
            label: t("prescription.template.hourDie"),
            dataElement: {
                placeholder: t(`prescription.template.hourDie_placeholder`),
                type: "text"
            },
            col: {xs: "6", sm: "6", lg: "1", xl: "1"},
            display: {
                form: "me-lg-5"
            }
        }
    ];

    const formStructurePulsedFlow = (type) => [
        {
            name: `pulsedFlow_${type}`,
            type: "radio",
            label: t(`prescription.template.typeFlow.label`),
            col: {xs: "6", sm: "4", lg: "3", xl: "3"},
            dataElement: {
                display: 'd-flex',
            },
            display: {
                form: "",
                label: "",
                child: ""
            },
            options: [
                {
                    value: 'pulsed',
                    label: t(`prescription.template.pulsedFlow.label`)
                },
                {
                    value: 'continuos',
                    label: t(`prescription.template.continuosFlow.label`)
                }],
        },
        /* ...(dataForm?.pulsedFlow ? [{
             type: "input",
             label: t(`prescription.template.pulsedFlowSettings.label`),
             dataElement: {
                 placeholder: t(`prescription.template.pulsedFlowSettings.placeholder`),
                 type: "text"
             },
             name: "pulsedFlowSettings",
             col: {xs: "12", lg: '6'}
         }] : [])*/
    ];

    const formStructureValid = [
        {
            name: "validUntil",
            type: "input",
            label: `${t("prescription.template.validUntil")}*`,
            dataElement: {
                type: "date"
            },
            extra: {
                type: "datePicker"
            },
            col: {xs: "12", sm: "12", lg: "3", xl: "3"}
        }
    ];
    const formStructureDateNextCheck = [
        {
            name: "dateNextCheck",
            type: "input",
            label: t("prescription.template.dateNextCheck"),
            dataElement: {
                type: "date"
            },
            extra: {
                type: "datePicker"
            },
            col: {xs: "12", sm: "12", lg: "3", xl: "3"}
        }
    ];

    const formPrescriptionType = [
        {
            name: "prescriptionType",
            type: "select",
            label: t("prescription.template.prescriptionType.title"),
            options: Object.keys(prescriptionTypeValue).map(ele => ({value: ele, label: t(prescriptionTypeLabel[ele])})),
            dataElement: {
                type: "text",
                multi: false
            },
            col: {xs: "12", sm: "12", lg: "6", xl: "6"}
        },
    ];

    return {
        formStructureModel,
        formStructurePathologies,
        formStructurePrescription,
        formStructureValid,
        formStructureStroller,
        formStructurePulsedFlow,
        formStructureDateNextCheck,
        formPrescriptionType
    };
};
